/* Avis Google iPhumat — chargeur PARTAGÉ (une seule requête par visite).
 *
 * Pourquoi centraliser : la note et le nombre d'avis sont affichés à plusieurs
 * endroits (hero, chiffres clés, tunnel de réservation, carrousel, pages
 * villes). Un fetch par section brûlerait le quota Places API pour rien.
 * Ici : UN appel, mis en cache 30 min dans sessionStorage, puis diffusion à
 * tous les points d'ancrage de la page.
 *
 * Points d'ancrage (n'importe où dans le thème) :
 *   [data-gr-rating]  → note (« 4,8 »)
 *   [data-gr-total]   → nombre d'avis (« 506 »)
 *   [data-gr-maps]    → <a> dont le href devient l'URL de la fiche Google
 *   [data-google-reviews] → conteneur de carrousel/grille à re-remplir
 */
(function () {
  var CACHE_KEY = 'iphumat:google-reviews:v1';
  var CACHE_TTL = 30 * 60 * 1000; // 30 min

  function endpoint() {
    var el = document.querySelector('[data-reviews-endpoint]');
    return (
      window.IPHUMAT_REVIEWS_ENDPOINT ||
      (el && el.getAttribute('data-reviews-endpoint')) ||
      'https://salut-hub-iphumat.odoo.com/iphumat/reviews'
    );
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.t || Date.now() - o.t > CACHE_TTL) return null;
      return o.d;
    } catch (e) {
      return null;
    }
  }

  function writeCache(d) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d }));
    } catch (e) {
      /* quota/private mode : on ignore, le fetch refera le travail */
    }
  }

  /* --- Diffusion aux compteurs de la page --------------------------------- */
  function paintCounters(d) {
    var rating = d.rating ? (Math.round(d.rating * 10) / 10).toString().replace('.', ',') : null;
    if (rating) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-gr-rating]'), function (el) {
        // Le compteur animé (stats) lit data-counter-to : on le resynchronise
        // pour qu'il ne réécrase pas la valeur live au scroll.
        if (el.hasAttribute('data-counter-to')) el.setAttribute('data-counter-to', String(d.rating));
        var suffix = el.getAttribute('data-counter-suffix') || '';
        el.textContent = rating + suffix;
      });
    }
    if (d.total) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-gr-total]'), function (el) {
        var pre = el.getAttribute('data-gr-prefix') || '';
        var post = el.getAttribute('data-gr-suffix') || '';
        el.textContent = pre + d.total + post;
      });
    }
    if (d.maps_url) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-gr-maps]'), function (a) {
        a.setAttribute('href', d.maps_url);
        if (a.tagName === 'A') {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener');
        }
      });
    }
  }

  /* --- Rendu des cartes d'avis -------------------------------------------- */
  function cardHTML(rv, fallbackUrl) {
    var link = rv.url || fallbackUrl || '';
    var n = Math.max(1, Math.min(5, parseInt(rv.rating, 10) || 5));
    var stars = new Array(n + 1).join('★') + new Array(6 - n).join('☆');
    var inner =
      '<span class="reviews__card-stars" aria-label="' + n + ' étoiles sur 5">' + stars + '</span>' +
      '<blockquote class="reviews__card-text">' + esc(rv.text) + '</blockquote>' +
      '<footer class="reviews__card-foot">' +
      '<span class="reviews__card-name">' + esc(rv.author) + '</span>' +
      '<span class="reviews__card-date">' + esc(rv.relative_time) + '</span>' +
      '</footer>';
    if (!link) return '<li class="reviews__card">' + inner + '</li>';
    return (
      '<li class="reviews__card reviews__card--link">' +
      '<a href="' + esc(link) + '" target="_blank" rel="noopener nofollow" ' +
      'aria-label="Lire l\'avis de ' + esc(rv.author) + ' sur Google">' +
      inner +
      '</a></li>'
    );
  }

  function paintReviews(d) {
    if (!d.reviews || !d.reviews.length) return;
    // On n'affiche QUE les avis avec un commentaire écrit. Google renvoie aussi
    // des avis « note seule » (texte vide) qui faisaient des cartes vides dans
    // le carrousel — on les écarte de l'affichage (la note et le total, eux,
    // restent basés sur TOUS les avis).
    var reviews = d.reviews.filter(function (rv) {
      return rv && rv.text && String(rv.text).trim();
    });
    if (!reviews.length) return; // aucun avis rédigé → on garde le repli Liquid
    var roots = document.querySelectorAll('[data-google-reviews]');
    Array.prototype.forEach.call(roots, function (root) {
      var container = root.querySelector('.reviews__track') || root.querySelector('.reviews__grid');
      if (!container) return;
      var html = reviews.map(function (rv) {
        return cardHTML(rv, d.maps_url);
      });
      // Carrousel : la boucle CSS translate de -50 %, il faut donc exactement
      // deux passes du même contenu pour que le raccord soit invisible.
      if (root.classList.contains('reviews--carousel')) html = html.concat(html);
      container.innerHTML = html.join('');
      root.setAttribute('data-gr-live', '');
      // La durée dépend du nombre de cartes, sinon 3 avis défilent à toute
      // vitesse et 10 avis rampent.
      var rail = root.querySelector('.reviews__rail');
      if (rail) rail.style.setProperty('--reviews-duration', Math.max(28, reviews.length * 7) + 's');
    });
  }

  /* --- Pause du carrousel au toucher (mobile) ------------------------------ */
  function bindTouchPause() {
    Array.prototype.forEach.call(document.querySelectorAll('.reviews--carousel .reviews__rail'), function (rail) {
      var track = rail.querySelector('.reviews__track');
      if (!track) return;
      var pause = function () { track.style.animationPlayState = 'paused'; };
      var play = function () { track.style.animationPlayState = ''; };
      rail.addEventListener('touchstart', pause, { passive: true });
      rail.addEventListener('touchend', play, { passive: true });
      rail.addEventListener('touchcancel', play, { passive: true });
    });
  }

  function apply(d) {
    if (!d || !d.ok) return;
    paintCounters(d);
    paintReviews(d);
    bindTouchPause();
  }

  function init() {
    var cached = readCache();
    if (cached) {
      apply(cached);
      return;
    }
    bindTouchPause();
    fetch(endpoint(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.ok) return;
        writeCache(d);
        apply(d);
      })
      .catch(function () { /* offline / API down : on garde les valeurs du thème */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
